import React, { useState, useEffect } from "react";
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell
} from "@material-ui/core";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import { abbreviateNumber } from "pages/dealScreener/Email/constants";
import styled from "styled-components";
import numeral from "numeral";

const paddingNumber = 5;

const theme = createMuiTheme({
  overrides: {
    MuiTableCell: {
      root: {
        "&:last-child": {
          paddingRight: paddingNumber
        }
      }
    }
  }
});

const StyledTable = styled(Table)`&& {
    background-color: #F4F4F4;
    border: 1px solid #DADCE0;
    table-layout: fixed;
    width: 100%;
    font-family: Work Sans;
}`;

const StyledProjectionCells = styled(TableCell)`&& {
    color: #000000;
    font-size: 10px;
    font-weight: 600;
    line-height: 14px;
    padding: 1em;
}`;

const ArrowTextWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 4px;
`;

const TriangleUp = styled.div`
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-bottom: 10px solid #50C40A;
    width: 0px;
    height: 0px;
`;

const NOIColumnCellPrimaryText = styled.div`
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
`;

const NOIColumnCellYearText = styled.div`
    font-size: 8px;
    font-weight: 400;
    line-height: 12px;
`;

const ProjectionCell = styled(TableCell)`&& {
    font-size: 10px;
    font-weight: 400;
    line-height: 14px;
    padding: 1em;
    color: #5F6368;
    word-spacing: -2px;
}`;

const NOIColumnCell = styled(TableCell)`&& {
    background-color: ${({ noiColor }) => `#${noiColor}`};
    padding: 1em;
    color: #FFFFFF;
    display: flex;
    flex-direction: column;
    gap: 4px;
    align-items: center;
}`;

const StyledNOIHeaderCell = styled(TableCell)`&& {
    color: #FFFFFF;
    font-size: 10px;
    font-weight: 600;
    line-height: 14px;
    background-color: ${({ noiColor }) => `#${noiColor}`};
    padding: 1em;
    width: 12%;
}`;

const ValuationSensitivityNOITable = ({ rawData, noiColor }) => {
  const [tableData, setTableData] = useState([]);
  const [headerCapRatePercentages, setHeaderCapRatePercentages] = useState([]);

  useEffect(() => {
    if (rawData?.length > 0) {
      const chronologicalData = rawData.sort((a, b) => a.year - b.year);
      setTableData(chronologicalData);
    }
  }, [rawData]);

  useEffect(() => {
    if (tableData.length > 0) {
      const capRates = tableData[0]?.noiProjections?.map(({ capRate }) => numeral(capRate).format("0.00%"));
      setHeaderCapRatePercentages(capRates);
    }
  }, [tableData]);

  return (
    <MuiThemeProvider theme={theme}>
      <StyledTable>
        <TableHead>
          <TableRow>
            <StyledNOIHeaderCell noiColor={noiColor}>NOI</StyledNOIHeaderCell>
            {headerCapRatePercentages?.map((capRate, idx) => <StyledProjectionCells key={`${capRate - idx}`}>{capRate}</StyledProjectionCells>)}
          </TableRow>
        </TableHead>
        <TableBody>
          {
                    tableData?.map(({ baseNoi, year, noiProjections }, index) => <TableRow key={`${year - index}`}>
                      <NOIColumnCell noiColor={noiColor}>
                        <ArrowTextWrapper>
                          <TriangleUp />
                          <NOIColumnCellPrimaryText>{numeral(baseNoi).format("$0,00")}</NOIColumnCellPrimaryText>
                        </ArrowTextWrapper>
                        <NOIColumnCellYearText>
                          {year}
                          {" "}
                          NOI
                        </NOIColumnCellYearText>
                      </NOIColumnCell>
                      {noiProjections?.map(({ valuation }, idx) => <ProjectionCell key={`${valuation - idx}`}>
                        $
                        {abbreviateNumber(valuation)}
                                                                   </ProjectionCell>)}
                    </TableRow>)
          }
        </TableBody>
      </StyledTable>

    </MuiThemeProvider>
  );
};

export default ValuationSensitivityNOITable;
